export default __webpack_public_path__ + "static/media/ncinema2.78a905c3.png";